import { viewOnlyMasqueradeAs } from "@/react/api/masqueradingApi";
import type { Paywall } from "@/react/types";
import { usePaywallActionConfirmationModal } from "../Modals/PaywallActionConfirmationModal";
import { ACTIONS } from "../Modals/PaywallActionConfirmationModal";
import { usePaywallActions } from "./usePaywallActions";

export const useChangePaywallStates = (
  paywall: Pick<Paywall, "id" | "status">,
  onConfirmCallback: () => void,
) => {
  const { publishPaywall, archivePaywall, deletePaywall } = usePaywallActions({
    paywall,
    refetchPaywalls: onConfirmCallback,
  });

  const paywallActionConfirmationModal = usePaywallActionConfirmationModal();

  const archive = () =>
    paywallActionConfirmationModal.show({
      paywall,
      action: ACTIONS.archive,
      onConfirm: archivePaywall,
    });

  const remove = () =>
    paywallActionConfirmationModal.show({
      paywall,
      action: ACTIONS.delete,
      onConfirm: deletePaywall,
    });

  const masquerade = () =>
    viewOnlyMasqueradeAs({
      entityId: paywall.id,
      entityType: "Paywall",
    })
      .then(data => window.open(data.masquerade_url, "_self"))
      .catch(error => console.error(error));

  return {
    publish: publishPaywall,
    archive,
    remove,
    masquerade,
  };
};
